export function inRange(number: number, min: number, max: number) {
    return number >= min && number <= max;
}

export type Timespan = [number, number];

/**
 * Takes two unix timestamp ranges as array ([from, to], [from, to]).
 *
 * @param {int[]} timespanA - [from, to]
 * @param {int[]} timespanB - [from, to]
 * @returns {boolean} Returns true if they overlap, false if they don't.
 */
export function timestampRangeOverlap(timespanA: Timespan, timespanB: Timespan): boolean {
    return Math.max(timespanA[0], timespanB[0]) <= Math.min(timespanA[1], timespanB[1]);
}
